import { Check } from "lucide-react";

import { cn } from "@/shared/lib/cn";

export interface StepperProps {
  steps: readonly string[];
  current: number; // 0-based
}

/**
 * Двух-/трёхшаговый индикатор. Текущий шаг — gradient + glow, пройденные —
 * галочка, будущие — приглушены. Линии между ними тоже подсвечиваются.
 */
export function Stepper({ steps, current }: StepperProps): JSX.Element {
  return (
    <ol className="flex items-center gap-2 sm:gap-4">
      {steps.map((label, idx) => {
        const done = idx < current;
        const active = idx === current;
        const isLast = idx === steps.length - 1;
        return (
          <li
            key={label}
            className="flex flex-1 items-center gap-2 sm:gap-3"
          >
            <div className="flex items-center gap-2 sm:gap-3">
              <div
                className={cn(
                  "flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold transition-all",
                  done && "bg-gradient-primary text-white shadow-glow-purple",
                  active &&
                    "bg-gradient-primary text-white shadow-glow-purple ring-2 ring-purple/40",
                  !done && !active &&
                    "border border-white/15 bg-white/[0.04] text-muted-foreground",
                )}
              >
                {done ? (
                  <Check className="h-4 w-4" />
                ) : (
                  <span>{idx + 1}</span>
                )}
              </div>
              <span
                className={cn(
                  "hidden text-sm font-semibold transition-colors sm:inline",
                  done && "text-foreground",
                  active && "text-white",
                  !done && !active && "text-muted-foreground",
                )}
              >
                {label}
              </span>
            </div>
            {!isLast && (
              <div
                className={cn(
                  "h-px flex-1 transition-colors",
                  done ? "bg-gradient-to-r from-purple to-cyan" : "bg-white/10",
                )}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
